import { memo, useCallback } from "react";
import type { GridRowIdGetter } from "@mui/x-data-grid";
import { FilterVariant } from "consts/filters";
import { TableGridMode } from "consts/table";
import { Filters as WaMessagingFilters, MenuItem } from "consts/waMessaging";
import { useFailedPhoneVerificationsActions } from "features/waMessaging/actions";
import {
    selectIsWaMessagingResourceLoading,
    selectIsWaMessagingResourceUninitialized,
    selectWaMessagingResourceSlice
} from "features/waMessaging/selectors";
import type { FailedPhoneVerification } from "features/waMessaging/types";
import Resource from "ui/layouts/Resource";
import Table from "ui/widgets/Table";

const FailedPhoneVerifications = () => {
    const { getFailedPhoneVerifications, downloadCsv } = useFailedPhoneVerificationsActions();

    const getRowId: GridRowIdGetter<FailedPhoneVerification> = useCallback(
        ({ phone }: FailedPhoneVerification) => phone,
        []
    );

    return (
        <Resource
            breadcrumbsProps={{
                heading: 'Failed Phone Verifications',
                links: [{ name: '' }],
                sx: { mb: 0 }
            }}
        >
            <Table
                mode={TableGridMode.FailedPhoneVerifications}
                selectIsTableUninitialized={selectIsWaMessagingResourceUninitialized(MenuItem.FailedPhoneVerifications)}
                selectIsTableLoading={selectIsWaMessagingResourceLoading(MenuItem.FailedPhoneVerifications)}
                selectTableDataSlice={selectWaMessagingResourceSlice(MenuItem.FailedPhoneVerifications)}
                fetchTableData={getFailedPhoneVerifications}
                downloadCsv={downloadCsv}
                filterTypes={new Map<FilterVariant, string[]>([
                    [FilterVariant.Text, [WaMessagingFilters.phone]]
                ])}
                getRowId={getRowId}
                LayoutProps={{ sx: { m: '24px 0px' } }}
                FiltersProps={{ sx: { m: 0 } }}
            />
        </Resource>
    );
};

export default memo(FailedPhoneVerifications);
